import { render } from "./UserMainPage.vue?vue&type=template&id=a1ef4f08"
import script from "./UserMainPage.vue?vue&type=script&lang=js"
export * from "./UserMainPage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__